// Styles for PrivateDining go here.
import styled from 'styled-components';

export const StyledPrivateDining = styled.div``;
